import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { withBoardAuth } from '@generated/server/boardAuth.server';
import { EtsyProductsBoard, SubscriptionsBoard } from '@api/BoardSDK';

export const getShop = createServerFn({ method: 'GET' })
  .validator(z.object({}).optional())
  .handler(async () => withBoardAuth(async () => {
    const res = await new EtsyProductsBoard()
      .items()
      .withColumns(['description', 'price', 'etsyLink', 'image', 'category', 'featured'])
      .where({ featured: true })
      .withPagination({ limit: 12 })
      .execute();
    return { items: res.items };
  }));

const subSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1),
  email: z.string().min(3),
  phone: z.string(),
  address: z.string().min(3),
  publication: z.string(),
  startMonth: z.string(),
  amount: z.number(),
  paymentMethod: z.string(),
  gift: z.boolean(),
  giftRecipient: z.string(),
  notes: z.string(),
});

export const createSubscription = createServerFn({ method: 'POST' })
  .validator((d: unknown) => subSchema.parse(d))
  .handler(async ({ data }) => withBoardAuth(async () => {
    const fields = {
        name: data.name,
        status: 'New' as const,
        email: { email: data.email, label: data.email },
        ...(data.phone ? { phone: { phone: data.phone, country: 'US' } } : {}),
        mailingAddress: data.address,
        publication: data.publication,
        startMonth: data.startMonth,
        amount: data.amount,
        paymentMethod: data.paymentMethod,
        gift: data.gift,
        giftRecipient: data.giftRecipient,
        notes: data.notes,
    };
    if (data.id) {
      await new SubscriptionsBoard().item(data.id).update(fields).execute();
      return { id: data.id };
    }
    const item = await new SubscriptionsBoard().item().create(fields).execute();
    return { id: item.id };
  }));
